import { Paper, Stack } from "@mui/material";
import type { Dayjs } from "dayjs";

import { WearableAggregationToggle } from "./WearableAggregationToggle";
import type { WearableAggregationMode } from "./wearableMetricAggregation";
import {
  type WearableRangeDays,
  WearableDateRangeChips,
} from "./WearableDateRangeChips";
import { WearablePeriodDateRow } from "./WearablePeriodDateRow";

export interface WearableFilterBarProps {
  rangeDays: WearableRangeDays;
  onRangeChange: (days: WearableRangeDays) => void;
  periodLabel: string;
  periodEnd: Dayjs;
  today: Dayjs;
  loading: boolean;
  onPrevDay: () => void;
  onNextDay: () => void;
  onPickDate: (date: Dayjs) => void;
  aggregationMode?: WearableAggregationMode;
  onAggregationModeChange?: (mode: WearableAggregationMode) => void;
}

/** Faixa verde unificada: presets de range + navegação de período. */
export function WearableFilterBar({
  rangeDays,
  onRangeChange,
  periodLabel,
  periodEnd,
  today,
  loading,
  onPrevDay,
  onNextDay,
  onPickDate,
  aggregationMode,
  onAggregationModeChange,
}: WearableFilterBarProps) {
  const showAggregationToggle = rangeDays > 1 && aggregationMode && onAggregationModeChange;

  return (
    <Paper
      elevation={0}
      sx={{
        width: "100%",
        p: { xs: 1, sm: 1.25 },
        backgroundColor: "primary800.main",
        color: "white",
        borderRadius: 2,
        flexShrink: 0,
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "stretch", sm: "center" }}
        justifyContent="space-between"
        spacing={{ xs: 1, sm: 1.25 }}
        sx={{ width: "100%" }}
      >
        <WearableDateRangeChips
          rangeDays={rangeDays}
          onChange={onRangeChange}
          disabled={loading}
          tone="onPrimary"
        />

        {showAggregationToggle ? (
          <WearableAggregationToggle
            value={aggregationMode}
            onChange={onAggregationModeChange}
            tone="onPrimary"
          />
        ) : null}

        <WearablePeriodDateRow
          periodLabel={periodLabel}
          periodEnd={periodEnd}
          today={today}
          loading={loading}
          onPrevDay={onPrevDay}
          onNextDay={onNextDay}
          onPickDate={onPickDate}
        />
      </Stack>
    </Paper>
  );
}
